<template>
  <div>
    <el-card>
      <h2>消费记录</h2>
      
      <el-table :data="recordList" border style="width: 100%; max-height: 600px; overflow-y: auto;">
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column label="用户信息">
          <template #default="{ row }">
            <div>账号：{{ row.user.account }}</div>
            <div>用户名：{{ row.user.username }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="amount" label="消费金额" />
        <el-table-column prop="type" label="消费类型" />
        <el-table-column prop="created_at" label="消费时间" />
        <el-table-column prop="remark" label="备注" />
      </el-table>

      <el-pagination
        :current-page="pagination.page"
        :page-size="pagination.limit"
        :total="total"
        @current-change="handlePageChange"
      />
    </el-card>
  </div>
</template>

<script>
import { getUserBalanceRecord } from '@/api/money';

export default {
  data() {
    return {
      recordList: [],
      pagination: {
        page: 1,
        limit: 20
      },
      total: 0
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      const params = {
        page: this.pagination.page,
        limit: this.pagination.limit
      };
      const { data } = await getUserBalanceRecord(params);
      this.recordList = data.items.map(item => ({
        ...item,
        user: item.user || { account: '', username: '' }
      }));
      this.total = data.total;
    },
    handlePageChange(page) {
      this.pagination.page = page;
      this.fetchData();
    }
  }
};
</script>

<style scoped>
.el-card {
  margin: 20px;
}

.el-pagination {
  margin-top: 20px;
  text-align: right;
}
</style>